import { render, staticRenderFns } from "./PagamentoIniciarReprovar.vue?vue&type=template&id=47ed1410"
import script from "./PagamentoIniciarReprovar.vue?vue&type=script&lang=js"
export * from "./PagamentoIniciarReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports